const LicenseKeys = {
	FROALA_LICENCE_KEY: 'nQE2uB1A1D1B1A2B1A5mEZXQUVJb1EZf1IWIAUKLJZMBQuD3E2D1C2C4G1I4F1A10C6==',
	GOJS_LICENCE_KEY:
		'73f943e1b36228a800ca0d2b113f69ef1bb37f3b9ed01ef45e5341f3ef0d68443089ee2b01838bc881fe19fb1978c28ad4c26c799e4b0069e136d2db40e484ade13377b6475a4587a20234d39faf7aa7fc2a21f3d0a574a3d97a93f2f4a8c4',
	GOJS_LICENCE_KEY_V3:
		'298647e0bb614bc702d90676423d6bbc5cf07e34cf960ef2050047f1b95c6d40219ee87804c19bc681a81efc122ec68edac66c2bc445023eb738d4d911e481f8b53475b0405b438aa05074c190fc2bb3ec7e24a2c4b525f2db6a9cf1eaabc7835df7fb',
	DEVEXTREME_LICENSE_KEY:
		'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjQ5ZmM2YTA4LWYwMTItMTFlNS04MGNmLTAwMTU1ZDYyNDcwMSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQxCn0=.r+fvBJWmKI7kYbGP0TbutE9OPHTipjMW6uW8HND+k+rQXiQUOhCSOIQqBXDle7R7/eU6sC8nbZxnrG1+JYv8KCp884RacOZBn4rFV2BtORqfXaDbccMFe5pSreaqOd4XB5Kg6A=='
};

export default LicenseKeys;
